import { Typography, type TypographyComponentVariant } from '@repo/ui';
import c from 'classnames';
import { ReactNode } from 'react';

import styles from './Badge.module.css';

export type BadgeState =
  | 'good'
  | 'ok'
  | 'bad'
  | 'new'
  | 'default'
  | 'tinyPlus'
  | 'outline';

interface BadgeProps {
  title: ReactNode;
  state?: BadgeState;
  // Escape hatch for per-usage styling (spacing, custom color, size, ...).
  className?: string;
  size?: 'md' | 'sm';
  variant?: TypographyComponentVariant;
  testId?: string;
}

const sizeMap: Record<
  NonNullable<BadgeProps['size']>,
  TypographyComponentVariant
> = {
  md: 'label',
  sm: 'chart-label',
};

export const Badge = ({
  title,
  state = 'default',
  className,
  size = 'md',
  variant,
  testId,
}: BadgeProps) => {
  return (
    <div
      className={c(
        styles.wrapper,
        styles[state] ?? styles.default,
        styles[size],
        className,
      )}
      data-testid={testId}
    >
      <Typography variant={variant ?? sizeMap[size]} className={styles.title}>
        {title}
      </Typography>
    </div>
  );
};
